import React from 'react';
import {
  string,
  shape,
  func,
} from 'prop-types';
import {
  Spinner,
  FlexContainer,
} from '@hyphengroup/cag-components';
import ErrorPage from 'pages/ErrorPage';
import { Query } from 'react-apollo';
import Layout from 'components/layout';
import { withTracking } from 'components/tracking';
import withApplicationConfig from 'containers/withApplicationConfig';
import { getStaticText, getImages, getAuthQueryVariables } from 'helpers/Utils';
import GetTWLandingPage from 'money101/overrides/queries/getTWLandingPage.gql';
import withUserAgent from 'containers/withUserAgent';
import LandingPageContent from './LandingPageContent';

export const landingPageStaticTextKeys = [
  'LANDING_PAGE_REMIND_TITLE',
  'LANDING_PAGE_REMIND_SUBTITLE',
  'LANDING_PAGE_REMIND_CANCEL_CTA_TEXT',
  'LANDING_PAGE_REMIND_CONFIRM_CTA_TEXT',
  'LANDING_PAGE_ERROR_HEADER',
  'LANDING_PAGE_ERROR_RETRY_CTA_TITLE',
  'LANDING_PAGE_ERROR_BACK_CTA_TITLE',
];

const LandingPage = ({
  language,
  localisation,
  contentstackKeys,
  history,
  vertical,
  track,
}) => {
  const landingPageName = history.location.pathname.replace('/', '');
  return (
    <Query
      query={GetTWLandingPage}
      variables={{
        seoMetaData: `${landingPageName}_LANDING_PAGE_SEO_META`,
        heroBanner: `${landingPageName}_LANDING_PAGE_HERO_BANNER`,
        termsAndCondition: `${landingPageName}_LANDING_PAGE_TNC`,
        productList: `${landingPageName}_LANDING_PAGE_${vertical}_PRODUCT`,
        vertical,
        language: localisation[language],
        ...getAuthQueryVariables({
          contentstackKeys,
          initailStaticTextKeys: [
            ...landingPageStaticTextKeys,
            `${landingPageName}_LANDING_PAGE_REDIRECT_HEADER`,
            `${landingPageName}_LANDING_PAGE_REMIND_CANCEL_CTA_LINK`,
            `${landingPageName}_LANDING_PAGE_CAMPAIGN_NAME`,
          ],
          initialComponentConfig: [
            `${landingPageName}_LANDING_PAGE_DESC`,
            `${landingPageName}_LANDING_PAGE_FORM`,
          ],
        }),
      }}
    >
      {({
        loading,
        data,
        error,
        refetch,
      }) => {
        if (loading) {
          return (
            <FlexContainer alignItems="center" justifyContent="center" height="80vh">
              <Spinner>
                <img
                  alt="reward_selection_loading"
                  src="https://images.contentstack.io/v3/assets/bltdf909986be592dae/blt0c517830084d869b/5e2164de2aa8e40a75136471/spinner@3x.png"
                  height={35}
                  width={35}
                />
              </Spinner>
            </FlexContainer>
          );
        }

        const staticTextList = getStaticText(data);
        const imageAndLinkList = getImages(data);
        const product = data?.verticalQuery?.result?.products || [];

        if (error || product.length !== 1) {
          return (
            <Layout
              {...data?.pageConfig}
              componentConfig={data?.componentConfig}
              seoMetadata={data?.seoMetadata}
              customerProfile={data?.customerProfile}
              staticText={staticTextList}
              images={imageAndLinkList}
              refetch={refetch}
            >
              <ErrorPage errorCode={error} />
            </Layout>
          );
        }
        return (
          <LandingPageContent
            staticTextList={staticTextList}
            imageAndLinkList={imageAndLinkList}
            refetch={refetch}
            data={data}
            history={history}
            language={localisation[language]}
            landingPageName={landingPageName}
            product={product[0]}
            track={track}
          />
        );
      }
      }
    </Query>
  );
};

LandingPage.propTypes = {
  match: shape({}).isRequired,
  localisation: shape({}).isRequired,
  language: string.isRequired,
  contentstackKeys: shape({}),
  history: shape({}).isRequired,
  vertical: string.isRequired,
  track: func.isRequired,
};

LandingPage.defaultProps = {
  contentstackKeys: {},
};

export default withApplicationConfig(withTracking(withUserAgent(LandingPage)), ['languages', 'contentstackKeys']);
